import { httpClient } from '@/api/http';

export interface AdminConfig {
  mstcToMsrRate: number;
  signupBonusPoints: number;
  msrRewardRate: number;
}

export async function getAdminConfig(): Promise<AdminConfig> {
  const { data } = await httpClient.get<AdminConfig>('/admin/config');
  return data;
}

export async function updateAdminConfig(payload: AdminConfig): Promise<AdminConfig> {
  const { data } = await httpClient.patch<AdminConfig>('/admin/config', payload);
  return data;
}
